import React from "react";
import Marquee from "react-fast-marquee";
import TickerIcon from "./TickerIcon";

export default function Targets() {
    return (
        <section aria-label="Targets section">
            <div className="flex flex-col -space-y-[6vw] mb-[6vw]">
                <h2 className="font-[900] text-green text-[6vw] text-center">ASSET ANALIZZATI</h2>
                <h2 className="font-[900] text-light text-[6vw] text-center">COSA MONITORIAMO</h2>
            </div>
            <div className="flex flex-col items-center justify-center">
                <div className="h-[80px] w-full">
                    <Marquee>
                        <TickerIcon name="adobe" />
                        <TickerIcon name="alphabet" />
                        <TickerIcon name="broadcom" />
                        <TickerIcon name="cisco" />
                        <TickerIcon name="eli_lilly" />
                        <TickerIcon name="general_electric" />
                        <TickerIcon name="meta" />
                        <TickerIcon name="microsoft" />
                        <TickerIcon name="procter_gamble" />
                        <TickerIcon name="visa" />
                        <TickerIcon name="apple" />
                        <TickerIcon name="campari" />
                        <TickerIcon name="enel" />
                        <TickerIcon name="erg" />
                        <TickerIcon name="ferrari" />
                        <TickerIcon name="hera" />
                        <TickerIcon name="mediobanca" />
                        <TickerIcon name="moncler" />
                        <TickerIcon name="nexi" />
                        <TickerIcon name="nvidia" />
                        <TickerIcon name="poste" />
                        <TickerIcon name="prysmian" />
                        <TickerIcon name="recordati" />
                        <TickerIcon name="saipem" />
                        <TickerIcon name="stm" />
                        <TickerIcon name="technoprobe" />
                        <TickerIcon name="terna" />
                        <TickerIcon name="tesla" />
                        <TickerIcon name="unicredit" />
                        <TickerIcon name="webuild" />
                    </Marquee>
                </div>
            </div>
        </section>
    );
}

